<template>
    <div v-if="loaded" class="plugin-summary__content">
        <p class="typographies-heading-h3 plugin-summary__content-title">
            {{ $l10n.__('Mes modules supplémentaires') }}
        </p>
        <div class="plugins-list">
            <plugin-item v-for="plugin of plugins" :key="plugin.title" :plugin="plugin" />
        </div>
    </div>
    <div v-else class="plugin-summary__loading">
        <CompassLoader size="large" />
    </div>
</template>
<script>
import pluginItem from 'vcomponents/sellsyaccountmanager/SubscriptionManager/pluginItem.vue';
export default {
    components: {
        pluginItem,
    },
    props: {
        activePlugins: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            plugins: [],
            loaded: false,
        };
    },
    async created() {
        this.plugins = this.activePlugins;
        try {
            const { data: response } = await ApiClient.get('staffs/me', {
                embed: ['subscriptions'],
            });
            const subscriptions = response?._embed?.subscriptions;
            for (const [key, subscription] of Object.entries(subscriptions)) {
                if (subscription) {
                    const plugin = this.plugins.find((plugin) => plugin.id === key);
                    plugin.plan = subscription?.plan;
                }
            }
            this.loaded = true;
        } catch (e) {
            this.loaded = true;
            console.error(e);
        }
    },
};
</script>

<style lang="scss" scoped>
.plugins-list {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: var(--spacing-3);
}

.plugin-summary {
    &__content {
        margin-top: var(--spacing-6);

        &-title {
            margin-bottom: var(--spacing-1);
            margin-top: 0;
        }
    }

    &__loading {
        display: flex;
        justify-content: center;
        margin-top: var(--spacing-6);
    }
}
</style>
